import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToolbarComponent } from './toolbar.component';
import {DxButtonModule, DxContextMenuModule, DxListModule, DxToolbarModule} from 'devextreme-angular';
import {RouterModule} from '@angular/router';
import {NotificationsPanelModule} from './notifications-panel/notifications-panel.module';



@NgModule({
  declarations: [ToolbarComponent],
    imports: [
        CommonModule,
        DxToolbarModule,
        DxButtonModule,
        RouterModule,
        DxListModule,
        DxContextMenuModule,
        NotificationsPanelModule
    ],
  exports: [ToolbarComponent]
})
export class ToolbarModule { }
